export default __webpack_public_path__ + "static/media/we-will-rock-you.gif";